import React from 'react'
import { useEffect, useState } from "react";
import { TabContent, TabPane } from 'reactstrap'

const WizardInnerLeftMenuContent = (props) => {
    const [tabs, setTabs] = useState([])
    const [component, setComponent] = useState({})


    useEffect(() => {
        // if (props.activeTab === 636) {
        //     props.subCategItems.map((item) => {
        //         if (!isNull(item.subCategoryItems1)) {
        //             if (item.subCategoryItems1.length > 0) {
        //                 setSubitem1(item.subCategoryItems1)
        //                 setTabsList([item.subCategoryItems1[0]])
        //                 setActiveTab(item.subCategoryItems1[0].key)
        //             }
        //         }
        //     })
        // } else if (props.activeTab === 639) { // Handle key 639
        //     props.subCategItems.map((item) => {
        //         if (!isNull(item.subCategoryItems2)) {
        //             if (item.subCategoryItems2.length > 0) {
        //                 setSubitem1(item.subCategoryItems2)
        //                 setTabsList([item.subCategoryItems2[0]])
        //                 setActiveTab(item.subCategoryItems2[0].key)
        //             }
        //         }
        //     })
        // } else {
        //     setActiveTab(null)
        //     setSubitem1([])
        // }
        setTabs(props.dynamicTabs)
        const activeComponent = props.subCategItems.filter((tab, key) => {
            return tab.right === true
        })[0]
        if (activeComponent !== undefined) {
            setComponent(activeComponent)
        }
    }, [props.activeTab])
    return (
        <>
            {tabs.length > 0 ? (
                <>
                    <TabContent activeTab={props.activeTab}>
                        {tabs &&
                            tabs.map((item) => {
                                return (
                                    <React.Fragment key={item.key}>
                                        <TabPane tabId={item.key}>
                                            {item.component}
                                        </TabPane>
                                    </React.Fragment>
                                )
                            })}
                    </TabContent>
                </>
            ) : (
                <TabContent activeTab={component.key}>
                    <React.Fragment key={component.key}>
                        <TabPane tabId={component.key}>
                            {component.component}
                        </TabPane>
                    </React.Fragment>
                </TabContent>
            )}
        </>
    )
}

export default WizardInnerLeftMenuContent
